import { getFlixTldFromHostname } from 'app/functions';
import { setCookie } from 'app/storage/coookie';

export const setCookieForDomain = ({
  cookieName,
  cookieValue,
  expiresInDays,
}: {
  cookieName: string;
  cookieValue: string;
  expiresInDays?: number;
}) => {
  const domain = getFlixTldFromHostname(document.location.hostname) || document.location.hostname;
  return setCookie(cookieName, cookieValue, { domain, expires: expiresInDays });
};
